import { render } from "./note.vue?vue&type=template&id=37a07f14&scoped=true"
import script from "./note.vue?vue&type=script&lang=js"
export * from "./note.vue?vue&type=script&lang=js"

import "./note.vue?vue&type=style&index=0&id=37a07f14&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-37a07f14"

export default script